import { AppLayout, NotificationsProvider } from '@src/components';
import { CoreProvider } from '@src/core';
import { InteractionProvider, ProjectProvider, SessionProvider } from '@src/modules';
import { FC } from 'react';
import { AppProvider, CacheProvider, LocalStorageProvider } from '~/contexts';
import { MainAppTheme } from '~/themes';
import { MainAppRouter } from './main-app.router';

const MainAppIndex: FC = () => (
  <MainAppTheme>
    <LocalStorageProvider>
      <NotificationsProvider>
        <AppProvider>
          <CoreProvider>
            <SessionProvider>
              <ProjectProvider>
                <InteractionProvider>
                  <CacheProvider>
                    <AppLayout>
                      <MainAppRouter />
                    </AppLayout>
                  </CacheProvider>
                </InteractionProvider>
              </ProjectProvider>
            </SessionProvider>
          </CoreProvider>
        </AppProvider>
      </NotificationsProvider>
    </LocalStorageProvider>
  </MainAppTheme>
);

export default MainAppIndex;
